import React from 'react';

const SinPrecio = (props) => {

  return (
        <div className="price no-price col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
          <h5 className="estiloSinPrecio">Por el momento no hay salidas vigentes en este mes. Pruebe en otro periodo</h5>
        </div>
        )
}

export default SinPrecio



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/SinPrecio.js